export const getRedirectUrl = (type: string): string => {
    const url = new window.URL(window.location.href);

    url.searchParams.set('jumioVerify', type);

    // restricted params
    [
        'transactionStatus',
        'customerInternalReference',
        'transactionReference',
        'errorCode'
    ].forEach(name => url.searchParams.delete(name));

    return url.toString();
};

export const handleRedirect = (url: string): void => {
    const { handleJumioRedirect } = window.Playtech.API;

    if (typeof handleJumioRedirect === 'function') {
        handleJumioRedirect(url);

        return;
    }

    location.href = url;
};
